import { useEffect } from 'react'

// components
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CImage
} from '@coreui/react-pro'

// helpers
import { getFileType } from 'src/helpers/get-file-type';

const AppModalFilePreview = ({
  file,
  setOpenFilePreview
}) => {
  let fileType;
  let fileUrl;

  if (file instanceof File) {
    fileType = getFileType(file?.name)
    fileUrl = URL.createObjectURL(file)
  } else {
    fileType = getFileType(file)
    fileUrl = file + `?t=${new Date().getTime()}`
  }

  useEffect(() => {
    window.addEventListener('keydown', handleEscKey)
    return () => window.removeEventListener('keydown', handleEscKey)
  }, [])

  const handleEscKey = (e) => {
    if (e.key == 'Escape') {
      setOpenFilePreview(null)
    }
  }

  switch (fileType) {
    case 'image':
      return (
        <CModal size='lg' alignment="center" visible={file} backdrop="static">
          <CModalHeader onClick={() => setOpenFilePreview(null)}>
            <CModalTitle>Image Preview</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CImage fluid rounded align='center' src={fileUrl} />
          </CModalBody>
        </CModal>
      )
    case 'pdf': 
      return (
        <CModal size='lg' alignment="center" visible={file} fullscreen>
          <CModalHeader onClick={() => setOpenFilePreview(null)}>
            <CModalTitle>PDF Preview</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <iframe className={fileType} width="100%" height="100%" frameborder="0" src={fileUrl}></iframe>
          </CModalBody>
        </CModal>
      )
    case 'docs':
      return (
        <CModal size='lg' alignment="center" visible={file} fullscreen>
          <CModalHeader onClick={() => setOpenFilePreview(null)}>
            <CModalTitle>Document Preview</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <iframe className={fileType} width="100%" height="100%" frameborder="0" src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}></iframe>
          </CModalBody>
        </CModal>
      )
    default:
      return <div />
  }

}

export default AppModalFilePreview